import { formatDate } from "src/v2/utils/formatter/date-format"

const CAMPOS_BOOLEANOS = ["ConversaoFacultativa", "ConversaoMandatoria"]

const formatDateOrDash = (value) => {
    if (!value) return "-"
    try {
        return formatDate(String(value).replace(/-/g, "/"))
    } catch {
        return "-"
    }
}

const formatNumberOrDash = (value) => {
    if (value === null || value === undefined || value === "") return "-"
    return Number(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

const formatIntegerOrDash = (value) => {
    if (value === null || value === undefined || value === "") return "-"
    return Number(value).toLocaleString("pt-BR")
}

const formatBooleanOrDash = (field) => (value) => {
    if (value === null || value === undefined) return "-"
    if (CAMPOS_BOOLEANOS.includes(field)) {
        if (value === 0) return "Não"
        if (value === 1) return "Sim"
    }
    return value
}

const formatTextOrDash = (value) =>
    value === null || value === undefined || value === "" ? "-" : value

export const EVENTOS_ORDINARIOS_COLUMNS = [
    { field: "DataReferencia", headerName: "Data Referência", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataEvento", headerName: "Data Evento", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataEventoEfetiva", headerName: "Data Evento Efetiva", minWidth: 140, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataLiquidacao", headerName: "Data Liquidação", minWidth: 120, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "Indexador", headerName: "Indexador", minWidth: 100, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "IndexadorCorrecaoPercentual", headerName: "Taxa Percentual", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "TaxaJuros", headerName: "Taxa Juros", minWidth: 100, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "JurosIncorporacaoProgramadaPercentual", headerName: "Juros Incorporação Programada", minWidth: 190, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "AplicacaoAmortizacao", headerName: "Aplicação sobre", minWidth: 130, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "AmortizacaoOrdinariaPercentual", headerName: "% Amortização Ordinária", minWidth: 170, valueFormatter: (p) => formatNumberOrDash(p?.value) },
]

export const EVENTOS_EXTRAORDINARIOS_COLUMNS = [
    { field: "DataReferencia", headerName: "Data Referência", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataEvento", headerName: "Data Evento", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataLiquidacao", headerName: "Data Liquidação", minWidth: 120, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "TipoEvento", headerName: "Tipo Evento", minWidth: 200, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "ValorPercentual", headerName: "Valor Percentual", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "ValorFinanceiro", headerName: "Valor Financeiro", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
]

export const PREMIO_COLUMNS = [
    { field: "DataReferencia", headerName: "Data Referência", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataPremio", headerName: "Data Prêmio", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "ValorPremio", headerName: "Valor Prêmio", minWidth: 120, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "TipoPremio", headerName: "Tipo Prêmio", minWidth: 180, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "FormulaPremio", headerName: "Fórmula Prêmio", minWidth: 300, valueFormatter: (p) => formatTextOrDash(p?.value) },
]

export const CONVERSIBILIDADE_COLUMNS = [
    { field: "DataReferencia", headerName: "Data Referência", minWidth: 110, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "PrecoConversao", headerName: "Preço Conversão", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "PremioConversao", headerName: "Prêmio Conversão", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "DataInicioPreco", headerName: "Data Início Preço", minWidth: 140, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "Ticker", headerName: "Ticker", minWidth: 90, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "ConversaoFacultativa", headerName: "Conversão Facultativa", minWidth: 160, valueFormatter: (p) => formatBooleanOrDash("ConversaoFacultativa")(p?.value) },
    { field: "ConversaoMandatoria", headerName: "Conversão Mandatória", minWidth: 160, valueFormatter: (p) => formatBooleanOrDash("ConversaoMandatoria")(p?.value) },
    { field: "DataInicioConversao", headerName: "Data Início Conversão", minWidth: 160, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "DataFimConversao", headerName: "Data Fim Conversão", minWidth: 150, valueFormatter: (p) => formatDateOrDash(p?.value) },
    { field: "LimiteConversao", headerName: "Limite Conversão", minWidth: 140, valueFormatter: (p) => formatNumberOrDash(p?.value) },
    { field: "TipoPrecoConversao", headerName: "Tipo Preço Conversão", minWidth: 160, valueFormatter: (p) => formatTextOrDash(p?.value) },
    { field: "JanelaPregoes", headerName: "Janela Pregões", minWidth: 120, valueFormatter: (p) => formatIntegerOrDash(p?.value) },
    { field: "PercentualPregoes", headerName: "Percentual Pregões", minWidth: 150, valueFormatter: (p) => formatNumberOrDash(p?.value) },
]